import IService from '../IService';
import app from 'app';

export default IService.extend({
  getAllRequest: null,

  getAllAbort() {
    if (app.xhrExpected(this.getAllRequest)) {
      this.getAllRequest.abort();
      this.getAllRequest = null;
    }
  },

  getAll(data) {
    return new Promise((resolve, reject) => {
      data = _.options(data, {
        /** search query */
        q: undefined,
        programmerId: undefined,
        brandId: undefined,
        myWork: false,
        /** storyPreview's lastUpdate */
        lastModifiedDate: undefined,
        /** page size */
        size: app.DASHBOARD_RESULTS_PER_PAGE,
        /** true - fetch only templates, false - only non-templates */
        template: undefined,
      });

      this.getAllRequest = $.ajax({
        url: app.apiUrl('/api/v1/draftStoryPreviews'),
        type: 'GET',
        timeout: app.TIME.minute(),
        data,

        error: (jqXHR, textStatus) => {
          if ('abort' !== textStatus) {
            reject(this.createError(jqXHR));
          }
        },

        dataType: 'json',
        success(res) {
          if (_.isEmpty(res.storyPreviews)) {
            resolve({ stories: [], noMore: true });
          } else {
            resolve({
              stories: res.storyPreviews,
              noMore: !res.storyPreviews || !res.storyPreviews.length,
            });
          }
        },
      }).always(() => {
        this.getAllRequest = null;
      });
    });
  },

  /**
   * Fetch draft story preview
   * @note: parallel execution should be allowed by design
   * @param storyId
   */
  get(storyId) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: app.apiUrl(`/api/v1/draftStoryPreviews/${storyId}`),
        type: 'GET',

        error: (jqXHR) => {
          reject(this.createError(jqXHR));
        },

        dataType: 'json',
        success(response) {
          if (!_.isEmpty(response)) {
            resolve(response);
          } else {
            reject();
          }
        },
      });
    });
  },
});
